import {
  WAREHOUSE,
  WAREHOUSE_LOADING,
  WAREHOUSE_SUBMITTING,
  WAREHOUSES,
  WAREHOUSES_LOADING,
} from '../constants/warehousesTypes';

const initialState = {
  data: [],
  isLoading: false,
  warehouse: null,
  isLoadingWarehouse: false,
  submitting: false,
};

const warehouses = (state = initialState, action) => {
  switch (action.type) {
    case WAREHOUSES:
      return {
        ...state,
        data: action.payload,
      };

    case WAREHOUSES_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case WAREHOUSE:
      return {
        ...state,
        warehouse: action.payload,
      };

    case WAREHOUSE_LOADING:
      return {
        ...state,
        isLoadingWarehouse: action.payload,
      };

    case WAREHOUSE_SUBMITTING:
      return {
        ...state,
        submitting: action.payload,
      };

    default:
      break;
  }

  return state;
};

export default warehouses;
